import { Timeline } from 'primereact/timeline';
import { useSearchParams } from 'react-router-dom';
import {
  MinimizedEpCatalog,
  MinimizedLvCatalog
} from '../../Helper/ApiHelper/LvEpNetworkHelper';
import {
  checkStepActivation,
  checkUserParticipation,
  STEP_IS_ACTIVE,
  STEP_WAS_ACTIVE
} from '../../Helper/Util/TimelineStepHelper';
import BeeChip from './BeeChip';
import './BeeTimeline.scss';
import BeeSwitch from './BeeSwitch';
import { connect } from 'react-redux';
import { AppDispatch, RootState } from '../../Redux/store';
import { useEffect, useRef, useState } from 'react';
import { extractUserId } from '../../Helper/Util/JwtHelper';
import {
  KeyValEntry,
  createNewKeyValueForOrgaAndPhase,
  readAllStoredKeyValuesForOrgaAndPhase,
  updateKeyValueForOrgaAndPhase
} from '../../Helper/ApiHelper/KeyValueNetworkHelper';
import _ from 'lodash';
import BeeLoadingSpinner from './BeeLoadingSpinner';
import { Toast } from 'primereact/toast';
import { DURATION_NOTIFICATION_ERROR_LONG } from '../../Helper/Statics/Constants';

type TimelineProps = {
  steps: TimelineStep[];
  currentPhase: TimelineStep;
};

export type TimelineStep = {
  id: string;
  title?: string;
  start: any;
  end: any;
  //fill from phase!!
  liegenschaftIds?: string[];
  userIds?: string[];
  publicMediaIds?: string[];
  //connected lvs
  lvs?: MinimizedLvCatalog[];
  //connected ep
  ep?: MinimizedEpCatalog;
};

export function BeeTimeline({ steps, currentPhase }: TimelineProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const toast = useRef<Toast>(null);

  function click(id: string) {
    if (searchParams.get('pId') !== id) {
      searchParams.delete('lId');
      searchParams.set('pId', id);
      setSearchParams(searchParams);
    }
  }

  ////////////////////
  // BUSINESS LOGIC //
  ////////////////////

  ////////////////
  // UI METHODS //
  ////////////////

  const customizedMarker = (item: TimelineStep, index: number) => {
    const cpClassNames = item.id === currentPhase.id ? ' currPhase' : '';
    const activation = checkStepActivation(item);
    const willUserParticipate = checkUserParticipation(item);
    if (willUserParticipate) {
      if (activation === STEP_IS_ACTIVE) {
        return (
          <div className={'chip clickable active ' + cpClassNames}>
            <BeeChip
              label={'' + (index + 1)}
              removable={false}
              type={'primary'}
              onClick={() => {
                click(item.id);
              }}
            />
          </div>
        );
      } else if (activation === STEP_WAS_ACTIVE) {
        return (
          <div className={'chip clickable wasActive ' + cpClassNames}>
            <BeeChip
              label={'' + (index + 1)}
              removable={false}
              type={'primary'}
              onClick={() => click(item.id)}
            />
          </div>
        );
      } else {
        <div className={'chip clickable willActive ' + cpClassNames}>
          <BeeChip
            label={'' + (index + 1)}
            removable={false}
            type={'primary'}
          />
        </div>;
      }
    }
    return (
      <div className={'chip non-clickable noParticipation ' + cpClassNames}>
        <BeeChip label={'' + (index + 1)} removable={false} type={'primary'} />
      </div>
    );
  };

  const customizedContent = (item: TimelineStep): JSX.Element => {
    const cpClassNames = item.id === currentPhase.id ? ' currPhase' : '';
    const activation = checkStepActivation(item);
    const willUserParticipate = checkUserParticipation(item);
    if (!willUserParticipate) {
      return (
        <div className={'bold phase non-clickable' + cpClassNames}>
          <div>{item.title + ' (keine Teilname)'}</div>
          <div>
            <span>
              {' '}
              {item.start
                ? new Date(item.start).toLocaleDateString('de-DE')
                : null}{' '}
            </span>
            <span>{'-'}</span>
            <span>
              {' '}
              {item.end ? new Date(item.end).toLocaleDateString('de-DE') : null}
            </span>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          {activation === STEP_IS_ACTIVE ? (
            <div
              onClick={() => {
                click(item.id);
              }}
              className={'bold phase clickable active' + cpClassNames}
            >
              <div>{item.title}</div>
              <div>
                <span>
                  {' '}
                  {item.start
                    ? new Date(item.start).toLocaleDateString('de-DE')
                    : null}{' '}
                </span>
                <span>{'-'}</span>
                <span>
                  {' '}
                  {item.end
                    ? new Date(item.end).toLocaleDateString('de-DE')
                    : null}
                </span>
              </div>
            </div>
          ) : activation === STEP_WAS_ACTIVE ? (
            <div
              onClick={() => {
                click(item.id);
              }}
              className={'bold phase clickable ' + cpClassNames}
            >
              <div> {item.title}</div>
              <div>
                <span>
                  {' '}
                  {item.start
                    ? new Date(item.start).toLocaleDateString('de-DE')
                    : null}{' '}
                </span>
                <span>{'-'}</span>
                <span>
                  {' '}
                  {item.end
                    ? new Date(item.end).toLocaleDateString('de-DE')
                    : null}
                </span>
              </div>
            </div>
          ) : (
            <div className={'bold phase non-clickable ' + cpClassNames}>
              <div> {item.title}</div>
              <div>
                <span>
                  {' '}
                  {item.start
                    ? new Date(item.start).toLocaleDateString('de-DE')
                    : null}{' '}
                </span>
                <span>{'-'}</span>
                <span>
                  {' '}
                  {item.end
                    ? new Date(item.end).toLocaleDateString('de-DE')
                    : null}
                </span>
              </div>
            </div>
          )}
        </div>
      );
    }
  };

  return (
    <div className="bee-timeline">
      <div className={'timeline'}>
        <Timeline
          value={steps}
          layout="horizontal"
          align="top"
          className="customized-timeline"
          marker={customizedMarker}
          content={customizedContent}
        />
      </div>

      <Toast ref={toast} position={'top-right'} />
    </div>
  );
}

export default BeeTimeline;
